/**
 * A bounded FIFO buffer that remembers how much it threw away.
 *
 * Every capture channel in a diagnostics bundle (console lines, breadcrumbs,
 * request ids) is a fixed-size window over an unbounded stream, and the bundle
 * records what it lost rather than losing it silently — so the drop count is
 * part of the buffer's contract, not an afterthought.
 */
export class RingBuffer<T> {
  private readonly entries: T[] = []
  private dropped = 0

  constructor(private readonly capacity: number) {}

  push(entry: T): void {
    this.entries.push(entry)
    if (this.entries.length > this.capacity) {
      this.entries.shift()
      this.dropped += 1
    }
  }

  /** A copy — callers serialise this into a payload that must not later mutate. */
  snapshot(): T[] {
    return [...this.entries]
  }

  droppedCount(): number {
    return this.dropped
  }
}
